import * as THREE from 'three';

// Loads the 70s hi-fi tools/build-hifi.mjs prepared for visualizers/hifi.js:
// the picture with everything off, the light the meters' backlight adds
// (diff), the lossless id map (light group, meter window, platter keep mask)
// and the measured constants (pivots, reels, platter homography). ONCE, at
// startup. The preload is a WIRING POINT every entry point must call (main,
// main-radio, play-boot, the capture harness); it resolves false when
// anything is missing so the entry point withdraws HiFi from the rotation.
const MANIFEST_URL = 'textures/hifi.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
function data(t) {
  t.colorSpace = THREE.NoColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.NearestFilter;
  t.magFilter = THREE.NearestFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadHifi() {
  if (_promise) return _promise.then(function (a) { return !!a; });
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('hifi.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.off, photo),
        loadTexture('textures/' + manifest.diff, photo),
        loadTexture('textures/' + manifest.ids, data),
        fetch('textures/' + manifest.data).then(function (r) {
          if (!r.ok) throw new Error(manifest.data + ' HTTP ' + r.status);
          return r.json();
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, off: parts[0], diff: parts[1], ids: parts[2], data: parts[3] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] hifi assets unavailable, HiFi is withdrawn', err);
      _assets = null;
      return null;
    });
  return _promise.then(function (a) { return !!a; });
}

export function getHifi() {
  return _assets;
}
